import humps from 'humps';
import { useMutation as _useMutation } from '@tanstack/react-query';

import COOKIES_KEY from 'constants/cookies';
import Cookies from 'js-cookie';
import { CustomError, fetcherMutation } from '@utils/react-query';

import { MutationFnArgs, UseMutationOptions } from './types';

const useMutation = <
  TData = unknown,
  TError = unknown,
  TVariables = void,
  TContext = unknown,
>(
  options: UseMutationOptions<TData, TError, TVariables, TContext>,
) => {
  const { mutationFn, ...resOptions } = options;
  return _useMutation<
    TData,
    CustomError<TError>,
    MutationFnArgs<TVariables>,
    TContext
  >({
    mutationFn: async ({ context: _context = {}, variables }) => {
      const { meta, ...resContext } = _context;

      const context = {
        path: '',
        meta: {
          ...meta,
          token: Cookies.get(COOKIES_KEY.TOKEN),
        },
        ...resContext,
      };

      const result = await (mutationFn
        ? mutationFn({ context, variables })
        : fetcherMutation({
            context,
            variables,
          }));

      return humps.camelizeKeys(result) as TData;
    },

    ...resOptions,
  });
};

export default useMutation;
